import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { withAuthentication } from "hocs/withAuthentication";
import RequestCard from "./RequestCard";
import {
    Title,
    ButtonWrapper,
    HeaderWrapper,
    FilterWrapper,
    EmptyViewWrapper,
    ErrorViewWrapper
} from "./styled";
import { Space, Loader } from "components";
import { filters } from "./consts";
import { ReactComponent as PlusIcon } from "assets/svgs/plus.svg";
import { getPurchaseOrders } from "./service";
import Layout from "../Layout";
import RequestDetailsModal from "./RequestDetailsModal";

const Filters = ({ match, counts }) => {
    return Object.keys(filters).map((filter, i) =>
        <NavLink key={i} to={`/${match.params.id}/purchase-orders/show/${filter}`}
                 activeClassName="active">
            <span>{counts[filters[filter]]}</span>
            {/* intentional space for text-transform: capitalize to work*/}
            &nbsp;{filter}
        </NavLink>
    );
};

const ErrorView = ({ err }) =>
    <ErrorViewWrapper>
        {err}
    </ErrorViewWrapper>;

const EmptyView = () =>
    <EmptyViewWrapper>
        No Purchase Order Requests Found
    </EmptyViewWrapper>;

const RequestsView = ({ roleId, role, email, ...props }) => {
    const [requests, setRequests] = useState([]);
    const [statusCounts, setStatusCounts] = useState({});
    const [err, setErr] = useState();
    const [activeRequest, setActiveRequest] = useState({});
    const [loading, setLoading] = useState(true);
    let isModalOpen = Object.keys(activeRequest).length !== 0;

    let orderID;
    let tabToActivate = 'details'; // should be only either details OR activity
    if (props.match.params.orderID) {
        orderID = props.match.params.orderID;
    }
    if (props.match.params.tab) {
        tabToActivate = props.match.params.tab;
    }

    const [statusFilter, setStatusFilter] = useState(filters[props.match.params.filter]);
    useEffect(() => {
        if (statusFilter === props.match.params.filter) {
            return;
        }

        // prevent un-necessary renders due to change in match
        // kind of cache implementation for `props.match.params.filter`
        setStatusFilter(filters[props.match.params.filter]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.match.params.filter]);

    const handleModalClose = () => {
        setActiveRequest({});
    };

    useEffect(() => {
        if (orderID){
            const matchingRequest = requests.find(r => r.objectId === orderID);
            setActiveRequest(matchingRequest || {});
        }
    }, [orderID, requests]);

    useEffect(() => {
        if (role && role.enablePurchaseOrderPortal === false) {
            setErr('This portal has not been enabled for public access. Please contact the administrator!');
            return;
        }

        setLoading(true);
        getPurchaseOrders(roleId, email, statusFilter)
            .then(response => {
                setRequests(response.requests);
                setStatusCounts(response.counts)
            })
            .then(() => setLoading(false))
            .catch(setErr);
    }, [role, roleId, email, statusFilter]);

    if (err) {
        return <Layout>
            <ErrorView err={err}/>
        </Layout>;
    }

    const Requests = ({ requests }) =>
        requests.map((req, i) =>
            <RequestCard
                key={i}
                request={req}
                onClick={setActiveRequest}
            />);

    return <Layout>
        <HeaderWrapper>
            <Title>My Purchase Order Requests</Title>
            <Link to={`/${roleId}/purchase-orders/create`}>
                <ButtonWrapper>
                    <PlusIcon/>
                    <span>Purchase Order Request</span>
                </ButtonWrapper>
            </Link>
        </HeaderWrapper>

        <Space/>
        <FilterWrapper>
            <Filters match={props.match} counts={statusCounts}/>
        </FilterWrapper>

        <Space/>
        {loading && <Loader/>}
        {!loading && requests.length === 0 && <EmptyView/>}
        {!loading && requests.length !== 0 && <Requests requests={requests}/>}

        <RequestDetailsModal
            isOpen={isModalOpen}
            onRequestClose={handleModalClose}
            activeRequest={activeRequest}
            tabToActivate={tabToActivate}
        />
    </Layout>
};

export default withAuthentication(RequestsView);
